import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";

const API = localStorage.getItem("assethost");

export default class CorporateProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      profile: null,
      companyProfile: {},
      showUpdate: false,
      msg: "",
      toastColor: "",
    };
  }
  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let userId =
      this.props.id || params.get("id") || sessionStorage.getItem("userId");
    this.loadProfile(userId);
  }
  loadProfile(userId) {
    const token = sessionStorage.getItem("token");
    if (!token || !userId) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(API + `/users/${userId}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const p = response.data || {};
        this.setState({
          loading: false,
          profile: p,
          companyProfile: p.companyProfile || {},
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load profile.",
          toastColor: "danger",
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    const company = s.companyProfile || {};
    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title={`Profile: ${s.profile?.fullName || "Corporate"}`} />
          {divMsg}
          <div className="w-full grow px-5 flex flex-col items-center justify-center overflow-y-auto">
            <div className="w-full max-w-3xl mt-8 mb-2 h-full overflow-y-auto">
              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Name</div>
                  <div>
                    {company.companyName || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Trading Name</div>
                  <div>
                    {company.tradingName || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Registration Number</div>
                  <div>
                    {company.registrationNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Physical Address</div>
                  <div>
                    {company.physicalAddress || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Primary Contact Firstname</div>
                  <div>
                    {company.primaryContactFirstName || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Primary Contact Surname</div>
                  <div>
                    {company.primaryContactSurname || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Primary Contact Role</div>
                  <div>
                    {company.primaryContactRole || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                {!company.primaryContactPassportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">
                      Primary Contact National ID Number
                    </div>
                    <div>
                      {company.primaryContactIdNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {company.primaryContactPassportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">
                      Primary Contact Passport Number
                    </div>
                    <div>
                      {company.primaryContactPassportNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Primary Contact Email</div>
                  <div>
                    {company.primaryContactEmail || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Primary Contact Number</div>
                  <div>
                    {company.primaryContactNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Billing Contact Firstname</div>
                  <div>
                    {company.billingContactFirstName || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Billing Contact Surname</div>
                  <div>
                    {company.billingContactSurname || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Billing Contact Role</div>
                  <div>
                    {company.billingContactRole || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Billing Contact National ID</div>
                  <div>
                    {company.billingContactIdNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Billing Contact Email</div>
                  <div>
                    {company.billingContactEmail || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Billing Contact Number</div>
                  <div>
                    {company.billingContactNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Company Type</div>
                  <div>
                    {company.companyType || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-8 mt-2">
              <button
                type="button"
                name="update"
                className="btn btn-success"
                onClick={() => this.setState({ showUpdate: true })}
              >
                Update Profile
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => window.history.back()}
              >
                Cancel
              </button>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
